import { STRINGS } from '../../constants';
import apiCaller from '../http';
import URLS from '../urls';

const askConfirmServiceScope = async (visitId, setError, refreshVisitDetail, logoutHandler) => {
  await apiCaller
    .put(`${URLS.VISIT_ASK_CONFIRM_SERVICE_SCOPE}${visitId}/`)
    .then((response) => {
      if (response.data !== undefined) {
        setError(null);
        refreshVisitDetail();
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e?.response?.data[0] === STRINGS.common.errorMissingWallet) {
        return setError(STRINGS.visit.noWalletBookingAlertMessage);
      }
      if (e?.response?.data[0] === STRINGS.common.errorMissingPaymentDetails) {
        return setError(STRINGS.visit.missingPaymentDetailsAlert);
      }
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400Text);
      }
      return null;
    });
};

export default askConfirmServiceScope;
